var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"pointer-event",attrs:{"id":"secondary-video"}},[_c('div',{staticClass:"videoPlayer",class:_vm.videoClasses})])
}
var staticRenderFns = []

export { render, staticRenderFns }